import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";

class SearchForm extends Component {
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <form onSubmit={this.props.handleSubmit}>
              <div className="row">
                <div className="offset3 span5 search-input">
                  <input
                    value={this.props.searchTerm}
                    onChange={this.props.handleChange}
                    required
                  />
                </div>
                <div className="span3 search-input">
                  <input
                    name="submit"
                    type="submit"
                    value={t("suchFormular.Button")}
                  />
                </div>
              </div>
            </form>
            <div className="row">
              <div className="offset3 span2 search-info-text-firstline">
                <b>{t("suchFormular.Tricks")}</b>
              </div>
              <div className="span3 search-info-text-firstline">
                {t("suchFormular.TricksKantonTitle")}
              </div>
              <div className="span4 search-info-text-firstline">
                {t("suchFormular.TricksExamples")}:{" "}
                <i>{t("suchFormular.TricksKantonExample")}</i>
              </div>
            </div>
            <div className="row">
              <div className="offset5 span3 search-info-text">
                {t("suchFormular.TricksWildcardTitle")}
              </div>
              <div className="span4 search-info-text">
                {t("suchFormular.TricksExample")}:{" "}
                <i>{t("suchFormular.TricksWildcardExample")}</i>
              </div>
            </div>
            <div className="row">
              <div className="offset3 span8 search-info">
                {t("suchFormular.Hints")}
              </div>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default withRouter(SearchForm);



// WEBPACK FOOTER //
// ./src/search-unified/SearchForm.js